import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50 border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer group">
          <div className={`w-9 h-9 rounded-lg flex items-center justify-center transition-colors ${
            scrolled || !isHome ? 'bg-primary-500' : 'bg-white/20 backdrop-blur-sm'
          }`}>
            <i className={`ri-fire-line text-lg ${
              scrolled || !isHome ? 'text-background-50 dark:text-foreground-950' : 'text-white'
            }`}></i>
          </div>
          <span className={`text-lg font-bold font-heading transition-colors ${
            scrolled || !isHome ? 'text-foreground-900' : 'text-white'
          }`}>
            91爆料网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              location.pathname === '/'
                ? scrolled || !isHome ? 'text-primary-500' : 'text-white font-semibold'
                : scrolled || !isHome ? 'text-foreground-700 hover:text-foreground-900' : 'text-white/80 hover:text-white'
            }`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button
            className={`w-9 h-9 rounded-lg flex items-center justify-center transition-colors cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100' : 'text-white/80 hover:text-white hover:bg-white/10'
            }`}
            aria-label="搜索"
          >
            <i className="ri-search-line"></i>
          </button>
          <Link
            to="/about"
            className={`px-4 py-2 rounded-md text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              scrolled || !isHome
                ? 'border border-foreground-300/60 text-foreground-700 hover:border-foreground-400 hover:text-foreground-900'
                : 'border border-white/30 text-white hover:bg-white/10'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          className={`md:hidden w-9 h-9 rounded-lg flex items-center justify-center cursor-pointer ${
            scrolled || !isHome ? 'text-foreground-700' : 'text-white'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-lg`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-3">
          <Link to="/" className="text-sm font-medium text-foreground-800 py-2 cursor-pointer">首页</Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="text-sm font-medium text-foreground-600 hover:text-primary-500 py-2 cursor-pointer"
            >
              {cat.name}
            </Link>
          ))}
          <hr className="border-background-200/70 my-1" />
          <Link to="/about" className="text-sm font-medium text-foreground-600 hover:text-primary-500 py-2 cursor-pointer">关于我们</Link>
        </div>
      )}
    </nav>
  );
}